<template>
  <a-tree-select
    v-model:value="value"
    show-search
    style="width: 100%"
    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
    placeholder="请选择部门"
    :treeData="departmentOptions"
    :replaceFields="{
      title: 'structureName',
      value: 'structureName',
    }"
    :disabled="disabled"
    tree-default-expand-all
    allow-clear
    @change="handleSelectDepartment"
  >
  </a-tree-select>
</template>

<script>
import { computed, defineComponent, watch, ref } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  props: {
    department: String,
  },
  setup(props, context) {
    const store = useStore();

    const user = store.state.user.user;

    const value = ref(null);
    const disabled = ref(false);
    // 过滤人员数据 留下组织架构数据
    const departmentOptions = computed(() => {
      // const ite = (iteList) => {
      //   const departmentList = iteList.filter((item) => {
      //     if (item.children && item.children.length > 0) {
      //       item.children = ite(item.children);
      //     }
      //     return String(item.id).indexOf("P") === -1;
      //   });

      //   return departmentList;
      // };
      // const list = ite(JSON.parse(JSON.stringify(store.state.noticeStaffData)));

      const structure = JSON.parse(JSON.stringify(store.state.noticeStaffData));

      const list = [];

      const firstLevelDepartment = user.firstLevelDepartment;

      let condition = "";

      switch (firstLevelDepartment) {
        case "研发中心":
          condition = "市场部,销售部,客户服务部";
          break;
        case "市场部":
          condition = "研发中心,销售部,客户服务部";
        case "客户服务部":
          condition = "研发中心,销售部,客户服务部";
          break;
        case "销售部":
          condition = "市场部,客户服务部";
          break;
        default:
          break;
      }

      structure[0].children.forEach((item) => {
        if (user.firstLevelDepartment === item.structureName) return;

        if (
          String(item.id).indexOf("P") === -1 &&
          item.structureName &&
          condition.indexOf(item.structureName) !== -1
        ) {
          list.push({
            structureName: item.structureName,
          });
        }
      });

      return list;
    });

    // 选择部门数据
    const handleSelectDepartment = (value, label, extra) => {
      context.emit("handleSelectDepartment", value);
    };

    // 监听数据改变
    watch(
      props.department,
      (val) => {
        value.value = val.value;
        disabled.value = val.disabled;
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      value,
      disabled,
      handleSelectDepartment,
      departmentOptions,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
